import type { LucideIcon } from "lucide-react";
import { Link } from "@/i18n/navigation";
import { Card, CardContent } from "@/components/ui/card";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: { label: string; href: string };
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-16 text-center">
        <div className="mb-4 rounded-lg bg-muted p-3">
          <Icon className="h-8 w-8 text-muted-foreground" />
        </div>
        <h2 className="font-heading text-lg font-semibold">{title}</h2>
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">
          {description}
        </p>
        {action && (
          <Link
            href={action.href}
            className="mt-4 text-sm text-primary hover:underline"
          >
            {action.label}
          </Link>
        )}
      </CardContent>
    </Card>
  );
}
